import type {
  DiscussionCategory,
  MergeStatus,
  ReviewState,
  Role,
  ThreadKind,
  ThreadState,
} from '../types/api';

/** URL segment and plural name of each conversation kind. */
export const SECTION: Record<ThreadKind, string> = {
  issue: 'issues',
  proposal: 'proposals',
  discussion: 'discussions',
};

export const KIND_LABEL: Record<ThreadKind, { one: string; many: string }> = {
  issue: { one: 'issue', many: 'issues' },
  proposal: { one: 'proposal', many: 'proposals' },
  discussion: { one: 'discussion', many: 'discussions' },
};

export const CATEGORY_LABEL: Record<DiscussionCategory, string> = {
  general: 'General',
  question: 'Question',
  idea: 'Idea',
  announcement: 'Announcement',
};

/** `/owner/wiki/issues/3`. `base` is `/owner/wiki`. */
export const threadPath = (base: string, kind: ThreadKind, number: number): string =>
  `${base}/${SECTION[kind]}/${number}`;

/** Who may write to a wiki. Presentation only: the API enforces it. */
export const canWrite = (role: Role): boolean => role === 'write' || role === 'admin' || role === 'owner';

export function stateLabel(kind: ThreadKind, state: ThreadState): string {
  if (state === 'merged') return 'Merged';
  if (state === 'open') return 'Open';
  return kind === 'proposal' ? 'Declined' : 'Closed';
}

export const REVIEW_LABEL: Record<ReviewState, string> = {
  none: 'Awaiting review',
  approved: 'Approved',
  changes_requested: 'Changes requested',
};

export const ROLE_LABEL: Record<Role, string> = {
  none: '',
  read: 'Reader',
  write: 'Maintainer',
  admin: 'Admin',
  owner: 'Owner',
};

export const MERGE_COPY: Record<MergeStatus, string> = {
  mergeable: 'These pages can be merged without conflicts.',
  conflicted: 'Some pages were changed differently in both wikis. Resolve them in the fork first.',
  up_to_date: 'There is nothing to merge: the pages already match.',
  source_unavailable: 'The wiki these pages came from is no longer available.',
  closed: 'This proposal is declined. Reopen it to merge.',
  merged: 'These pages were merged.',
};
